module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAASJJREFUSEvtlaFuwzAQhn9nhgGFkULHCwcGBgqmPEGljEb3EH2APsTJUdikPUFQQB9gYHygBeF7gOZSOW2nLMq6WM2qghqe7fvuP5/vVF3Xd/jHpS4CYOYFgNnIQgoiWjYKmLkAMAXwMRKk8UVEszYA1jAG4BBw4+8G6M3odaSImd9seEQ0P4bpYLNVefqR2zJbgO+LQ22/VpFDtH1K/1Zwzn+4jke+Kegr02433fq+T3Ecb/I812VZxiLyAkAPSN/PbmqMWYhIu5NObPvWWj+LSCgidl7cA1gD2AwAwPO8IkmS/TzoXjDGPImIreUvABOl1KdSahmG4WsURdshgOOZXkCapo9VVa3OcXwSYDezLHsIguDdNeKuussMfZecup7dAb95HCgD0b7DAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/imgs/user/icon-15.png
// module id = X5Ej
// module chunks = 0